/**
 * Per-country AdMob ids.
 *
 * Each country has its own AdMob app (own `appId`, own ad units) since they're
 * separate Play Store / App Store listings. `appId` isn't consumed here — the
 * Google Mobile Ads SDK reads it from the native manifest/plist directly
 * (see `apps/mobile-{cr,cn,ni}/android/.../AndroidManifest.xml` and
 * `apps/mobile-{cr,cn,ni}/ios/App/App/Info.plist`) — it's kept here only so the
 * native values have one documented source of truth.
 *
 * Ad unit ids are not secrets (they identify the ad slot to Google);
 * they're expected to ship inside the app bundle.
 */

export const ADMOB_CR = {
  publisherId: "ca-app-pub-7082278595197706",
  appId: "ca-app-pub-7082278595197706~4255006482",
  banner: "ca-app-pub-7082278595197706/3216422830",
  interstitialPlayChannel: "ca-app-pub-7082278595197706/6546768537",
  appOpen: "ca-app-pub-7082278595197706/5485242307",
} as const;

export const ADMOB_CN = {
  publisherId: "ca-app-pub-7082278595197706",
  appId: "ca-app-pub-7082278595197706~4550573356",
  banner: "ca-app-pub-7082278595197706/7348952077",
  interstitialPlayChannel: "ca-app-pub-7082278595197706/9611328344",
  appOpen: "ca-app-pub-7082278595197706/7191394031",
} as const;

/**
 * Nicaragua's AdMob app also has per-tab banner units (`bannerNews`,
 * `bannerRadio`). The shared bundle only places one banner unit today
 * (`AdConfig.bannerUnitId`), so those two are recorded here for when
 * per-placement banners land — they're not wired up yet.
 */
export const ADMOB_NI = {
  publisherId: "ca-app-pub-7082278595197706",
  appId: "ca-app-pub-7082278595197706~2552393141",
  banner: "ca-app-pub-7082278595197706/7230004754",
  bannerNews: "ca-app-pub-7082278595197706/7402855569",
  bannerRadio: "ca-app-pub-7082278595197706/5724858106",
  interstitialPlayChannel: "ca-app-pub-7082278595197706/8734658110",
  appOpen: "ca-app-pub-7082278595197706/5466356699",
} as const;
